package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun FormField(
    label: String,
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    type: InputType<String> = InputType.Text,
    fieldWidth: CSSSizeValue<CSSUnit.px> = 380.px
) {
    Column(
        modifier = Modifier
            .gap(10.px)
    ) {
        P(
            attrs = Modifier
                .fontSize(18.px)
                .color(Colors.borders)
                .fontWeight(FontWeight.Medium)
                .fontFamily(INTER)
                .margin(0.px)
                .toAttrs()
        ) {
            Text(label
            ) }

        Input(
            type = type,
            attrs = Modifier
                .width(fieldWidth)
                .height(45.px)
                .borderRadius(5.px)
                .backgroundColor(Colors.field.copy(alpha = 40))
                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                .padding(12.px)
                .fontSize(16.px)
                .fontFamily(INTER)
                .color(Colors.Black)
                .toAttrs {
                    placeholder(placeholder)
                    value(value)
                    onInput { onValueChange(it.value) }
                }
        )
    }
}